import { render, staticRenderFns } from "./TaxAssessmentDetail.vue?vue&type=template&id=445a1261&"
import script from "./TaxAssessmentDetail.vue?vue&type=script&lang=ts&"
export * from "./TaxAssessmentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TaxAssessmentDetail.vue?vue&type=style&index=0&id=445a1261&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports